import { render } from "./TableHint.vue?vue&type=template&id=5cf12729"
import script from "./TableHint.vue?vue&type=script&lang=ts"
export * from "./TableHint.vue?vue&type=script&lang=ts"

import "./TableHint.vue?vue&type=style&index=0&id=5cf12729&lang=scss"
script.render = render

export default script